import { render, staticRenderFns } from "./SafeBox.vue?vue&type=template&id=55b58ffa&"
import script from "./SafeBox.vue?vue&type=script&lang=js&"
export * from "./SafeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports